import { makeContext } from '../../utils'
import { initialProvider } from './initial'

export const { Provider: BitlabsProvider, useContext: useBitlabs } = makeContext(initialProvider === 'bitlabs', 'BitlabsProviderContext')
